<!--
 * @Author: natsu
 * @Date: 2020-11-27 15:30:53
 * @LastEditors: natsu
 * @LastEditTime: 2021-03-25 13:27:45
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <!-- <router-link to="/" class="back">← 返回首页</router-link> -->
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/element-ui.png" /></div>
      <p>Element-UI</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/element-ui/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "2.15.10",
          linkList: [
            ur + "2.15.10/index.js",
            ur + "2.15.10/locale/lang/zh-CN.js",
            ur + "2.15.10/theme-chalk/index.css"
          ]
        },
        {
          label: "2.15.6",
          linkList: [
            ur + "2.15.6/index.js",
            ur + "2.15.6/locale/lang/zh-CN.js",
            ur + "2.15.6/theme-chalk/index.css"
          ]
        },
        {
          label: "2.15.1",
          linkList: [
            ur + "2.15.1/index.js",
            ur + "2.15.1/locale/lang/zh-CN.js",
            ur + "2.15.1/theme-chalk/index.css"
          ]
        },
        {
          label: "2.14.1",
          linkList: [
            ur + "2.14.1/index.js",
            ur + "2.14.1/locale/lang/zh-CN.js",
            ur + "2.14.1/theme-chalk/index.css"
          ]
        },
        {
          label: "2.13.2",
          linkList: [
            ur + "2.13.2/index.js",
            ur + "2.13.2/locale/lang/zh-CN.js",
            ur + "2.13.2/theme-chalk/index.css"
          ]
        },
        {
          label: "2.9.2",
          linkList: [
            ur + "2.9.2/index.js",
            ur + "2.9.2/locale/lang/zh-CN.js",
            ur + "2.9.2/theme-chalk/index.css"
          ]
        },
        {
          label: "2.8.2",
          linkList: [
            ur + "2.8.2/index.js",
            ur + "2.8.2/locale/lang/zh-CN.js",
            ur + "2.8.2/theme-chalk/index.css"
          ]
        },
        {
          label: "2.4.6",
          linkList: [
            ur + "2.4.6/index.js",
            ur + "2.4.6/locale/zh-CN.js",
            ur + "2.4.6/locale/zh-CN.min.js",
            ur + "2.4.6/theme-chalk/index.css"
          ]
        },
        {
          label: "2.4.0",
          linkList: [
            ur + "2.4.0/index.js",
            ur + "2.4.0/locale/zh-CN.js",
            ur + "2.4.0/locale/zh-CN.min.js",
            ur + "2.4.0/theme-chalk/index.css"
          ]
        },
        {
          label: "2.3.9",
          linkList: [
            ur + "2.3.9/index.js",
            ur + "2.3.9/locale/zh-CN.js",
            ur + "2.3.9/locale/zh-CN.min.js",
            ur + "2.3.9/theme-chalk/index.css"
          ]
        },
        {
          label: "2.3.8",
          linkList: [
            ur + "2.3.8/index.js",
            ur + "2.3.8/locale/zh-CN.js",
            ur + "2.3.8/locale/zh-CN.min.js",
            ur + "2.3.8/theme-chalk/index.css"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListElementUi.vue